var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoloBronze1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 240,
    width: 160,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "solo_bronze_1_svg__a",
    cx: 57,
    cy: 57,
    r: 57
  }), /*#__PURE__*/React.createElement("mask", {
    id: "solo_bronze_1_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#solo_bronze_1_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6f472f",
    transform: "translate(17 43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 120h58v36l-29 19.44L34 156zM12 11.215C24 3.738 40.833 0 62.5 0S101 3.738 113 11.215l-10 43H22z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 83,
    r: 63
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 69)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#3d2719",
    xlinkHref: "#solo_bronze_1_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.308 116V77.106c-5.796-1.227-9.335-2.41-10.617-3.549-7.306-6.488-7.672-12.665-7.69-25.396L34 46.095c0-21.072 7.386-29.103 7.682-29.415l.009-.01c-1.344 16.277-1.899 27.014-1.665 32.212.575 12.764 3.19 16.936 3.764 17.706l.04.051c.047.06.072.088.072.088 2.29 2.187 3.837 3.316 4.64 3.387.944.084 2.05-.406 3.318-1.468.736.242 1.472-3.624 2.209-11.599C53.84 42.681 54.817 27.998 57 13l.247 1.73c2.01 14.397 2.904 28.503 2.684 42.317.737 7.975 1.473 11.841 2.21 11.599 1.267 1.062 2.373 1.552 3.317 1.468.803-.071 2.35-1.2 4.64-3.387 0 0 .025-.027.072-.088l.04-.051c.574-.77 3.19-4.942 3.764-17.706.234-5.198-.32-15.935-1.665-32.212l.01.01c.295.312 7.681 8.343 7.681 29.415v.527l-.001 1.539c-.018 12.731-.384 18.908-7.69 25.396-1.282 1.14-4.821 2.322-10.617 3.549V116z",
    fill: "#ffa672",
    mask: "url(#solo_bronze_1_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80 8l15 21-15 21-15-21z",
    fill: "#ffa672"
  }))));
}
export default SvgSoloBronze1;